import { createContext, useContext } from 'react'

type FabulousContext = {
  /**
   * When you are using the `Fabulous.Menu`
   */
  isOpen: boolean

  /**
   * Internal detection wheter we have painted a `Fabulous.Menu` inside
   */
  hasMenu: boolean

  /**
   * When you are using the `Fabulous.Menu`
   */
  openMenu: () => void

  /**
   * When you are using the `Fabulous.Menu`
   */
  closeMenu: () => void

  /**
   * Internal registration when we used the Fabulous.Menu and unregistration when you remove the items
   */
  registerMenu: (arg: boolean) => void
}

export const FabulousMenuContext = createContext<FabulousContext | null>(null)

export const useFabulousMenu = () => {
  const ctx = useContext(FabulousMenuContext)

  if (!ctx) {
    throw new Error('not used within a FabulousProvider.')
  }

  return ctx
}
